<template>
	<nk-table :data="tableData" :options="tableOptions" v-model="selectedRow" @active-index="changeActiveIndex" ref="table" tabindex="1" startup></nk-table>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters, mapActions } from 'vuex'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import emptyId from '~/statics/empty-id'
	import Switch from '~/components/general/nikan-switch.vue'
	import BooleanView from '~/components/form/boolean-label'

	export default {
		name: 'nk-app-state-list',
		props: {
			data: {},
			options: {}
		},
		emits: ['close-button-clicked', 'buttons-changed', 'resolve'],
		data() {
			return {
				settings: {
					key: ''
				},
				tableOptions: {
					searchable: false,
					gridSettingsEnabled: false,
					editable: true,
					addNewRowOnInit: false,
					actions: [
						{
							shortcut: $sc.find('templates-select', 'table'),
							handle: (row, index, collection, col) => {
								row.isActive = !row.isActive
								this.setAsActive(row)
								return true
							}
						}
					],
					columns: [
						{
							name: 'rowNumber',
							title: '...',
							width: 50,
							resizable: false,
							pinnable: false,
							pinned: true,
							entering: false
						},
						{
							name: 'name',
							title: this.$t('app-state-list.table.cols.name'),
							width: 'auto',
							pinnable: false,
							type: 'number',
							searchable: true,
							editable: true,
							edit: {
								component: Input,
								options: {
									mode: 'string'
								}
							}
						},
						{
							name: 'isActive',
							title: this.$t('app-state-list.table.cols.is-active'),
							pinnable: false,
							searchable: false,
							editable: true,
							entering: true,
							type: 'dropdown',
							search: {
								prefix: 'boolean-active-deactive',
								useTranslate: true,
							},
							view: {
								component: BooleanView,
								options: {
									useColors: true
								}
							},
							edit: (row, col) => {
								return {
									component: Switch,
									options: {
										mode: 'number',
										onChangeHandler: () => this.setAsActive(row)
									}
								}
							}
						}
					]
				},
				tableData: null,
				selectedRow: null,
				activeGridIndex: null,
				buttons: [
					{
						icon: 'times',
						isDanger: true,
						isPrimary: true,
						handle: (button, page, e) => {
							this.$emit('close-button-clicked')
						}
					},
					{
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						icon: 'save',
						isPrimary: true,
						handle: (button, page, e) => {
							this.save(this.settings.key, this.localTemplate)
						}
					},
					{
						title: this.$t('delete'),
						shortcut: $sc.find('delete'),
						icon: 'delete',
						// isPrimary: true,
						visible: true,
						handle: async (button, page, e) => {
							this.tableData.map(x => {
								if (this.selectedRow.id === x.id) {
									x.rowState = 'deleted'
								}
							})
							this.modifyStates(this.tableData)
							this.selectedRow = null
							await this.syncStates()
							this.tableData = this.getStatesByKey(this.settings.key)
						}
					},
					{
						title: this.$t('app-state-list.buttons.add-new'),
						shortcut: $sc.find('add'),
						icon: 'plus',
						handle: (button, page, e) => {
							this.saveAs(
								this.settings.key,
								this.localTemplate,
								this.tableSettings
							)
						}
					}
				],
				localTemplate: null
			}
		},
		computed: {
			...mapGetters('appStates', {
				getStatesByKey: 'getByKey',
				getActiveStatesByKey: 'getActiveByKey'
			})
		},

		watch: {
			data: {
				handler(newData) {
					this.localTemplate = newData
				}
			},
		},

		created() {
			this.settings = _.extend({}, this.settings, this.options)
			this.tableData = this.getStatesByKey(this.settings.key)
			this.selectedRow = this.getActiveStatesByKey(this.settings.key)
			this.localTemplate = {
				columns: this.data.columns,
				tableSettings: this.data.tableSettings
			}

			this.buttons[1].visible = this.tableData.length > 0
		},

		mounted() {
			this.prepareWindow('', this.buttons)
		},
		methods: {
			...mapActions('appStates', {
				modifyStates: 'modify',
				syncStates: 'sync',
				refreshStates: 'refresh'
			}),
			changeActiveIndex(newData) {
				if (newData > -1 && this.selectedRow) {
					this.buttons[2].visible = true
				} else {
					this.buttons[2].visible = false

				}
				this.$emit('buttons-changed', this.buttons)
			},
			save(key, template) {
				return new Promise((resolve, reject) => {
					var wait = this.$wait(this.$el)

					this.$refs.table
						.commitChanges()
						.then((items) => {
							for (let s of items) {
								if (s.key === key) {
									if (s.isActive) {
										s.value = template
										if (s.rowState === 'unchanged') {
											s.rowState = 'changed'
										}
									}
								}
							}

							return items
						})
						.then((items) => this.modifyStates(items))
						.then(() => this.syncStates())
						.then(() => wait.end(this.$refs.table.$el))
						.then(() => {
							this.tableData = this.getStatesByKey(key)
						})
						.then(() => {
							this.buttons[1].visible = this.tableData.length > 0
							this.$emit('buttons-changed', this.buttons)
							resolve()
						})
						.catch((error) => {
							wait.end(this.$refs.table.$el)
							this.logger.error(error)
							reject(error)
						})
				})
			},
			changeActive(key, template) {
				return new Promise((resolve, reject) => {
					// this.setCurrentTemplate(template)

					var wait = this.$wait(this.$el)

					this.$refs.table
						.commitChanges()
						// .then((items) => this.modifyStates(items))
						// .then(async () => await this.syncStates())
						// .then(() => wait.end(this.$refs.table.$el))
						// .then(() => {
						// 	this.tableData = this.getStatesByKey(key)
						// })
						.then(() => {
							this.buttons[1].visible = this.tableData.length > 0
							this.$emit('buttons-changed', this.buttons)
							wait.end()
							resolve()
						})
						.catch((error) => {
							wait.end(this.$refs.table.$el)
							this.logger.error(error)
							reject(error)
						})
				})
			},
			saveAs(key, template) {
				var wait = this.$wait(this.$el)

				this.$refs.table
					.commitChanges()
					.then((items) => {
						for (let s of items) {
							if (s.key === key) {
								s.isActive = false

								if (s.rowState === 'unchanged') {
									s.rowState = 'changed'
								}
							}
						}

						var tmpl = {
							id: emptyId,
							key: key,
							name:
								this.$t('app-state-list.theme') + ' ' + Number(items.length + 1),
							value: {
								columns: template.columns,
								tableSettings: {
									searchBarEnabled: template.tableSettings.searchBarEnabled
								}
							},
							isActive: true,
							rowState: 'new'
						}

						items.push(tmpl)
						return items
					})
					.then((items) => this.modifyStates(items))
					.then(() => this.syncStates())
					.then(() => wait.end(this.$refs.table.$el))
					.then(() => {
						this.tableData = this.getStatesByKey(key)
					})
					.then(() => {
						this.buttons[1].visible = this.tableData.length > 0
						this.$emit('buttons-changed', this.buttons)
					})
					.catch((error) => {
						wait.end(this.$refs.table.$el)
						this.logger.error(error)
					})
			},
			setCurrentTemplate(template) {
				var active = this.tableData.filter((x) => x.isActive === true)
				if (active.length === 0) {
					return
				}

				active[0].rowState = 'changed'
			},
			async setAsActive(row) {
				this.tableData.map(x => {
					if (row.id === x.id) {
						x.isActive = row.isActive
						x.rowState = 'changed'
					}
					if (row.isActive && row.id !== x.id) {
						if (x.isActive) {
							x.isActive = false
							x.rowState = 'changed'
						}
					}
				})
				this.modifyStates(this.tableData)
				await this.syncStates()
				this.$emit('resolve')
			}
		},
	}
</script>
<style></style>
